'use client';
import styles from './index.module.scss';

export default function EditorTooltip({ children }: { children: React.ReactNode }) {
    return (
        <dialog className={`${styles.EditorTooltip} EditorTooltip`}>
            <span className="EditorTooltip-arr"></span>
            <div className={`EditorTooltip-content`}>{children}</div>
        </dialog>
    );
}
